export function getApiPath(path: string) {
  return `/api${path}`
}
